// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"fd3918b1","453":"62fb1eb1"}[chunkId] + ".chunk.js";
};